import React from 'react';
import { Redirect } from 'expo-router';
export default function LearnRedirect() { return <Redirect href="/docs#learn" />; }
